import _ from 'lodash'
import createCrudModule from 'vuex-crud'
import api from 'utils/api'

const state = {
  currentUser: null,
  currentAccount: null,
  projectUsers: []
}

const getters = {
  isSuperAdmin: (state) => {
    return state.currentUser && state.currentUser.attributes.role === 'super_admin';
  },

  isAccountAdmin: (state) => {
    return state.currentUser && state.currentUser.attributes.role === 'account_admin';
  },

  isBusinessAdmin: (state) => {
    return state.currentUser && state.currentUser.attributes.role === 'business_admin';
  },

  isAnyAdmin: (state) => {
    return state.currentUser && state.currentUser.attributes.role !== 'non_admin';
  }
}

const mutations = {
  setCurrentAccount: (state, account) => {
    state.currentAccount = account;
  }
}

export default createCrudModule({
  client: api.client,
  resource: 'profile',
  parseSingle: res => res.data,
  customUrlFn: (id, projectId) => '/profile',
  onFetchSingleSuccess: (state, { data, included }) => {
    state.currentUser     = data;
    const accountRel      = data.relationships.account.data,
          projectUserIds  = _.map(data.relationships.project_users.data, 'id');
    state.currentAccount  = _.find(included, o => accountRel.id === o.id && o.type === 'account');
    state.projectUsers    = _.filter(included, o => _.includes(projectUserIds, o.id) && o.type === 'project_user');
  },
  state,
  getters,
  mutations
})